// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type FastTimer48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const FastTimer48Filled: FC<FastTimer48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path d="M30 40c-4.467 0-8.25-1.55-11.35-4.65C15.55 32.25 14 28.467 14 24s1.55-8.25 4.65-11.35C21.75 9.55 25.533 8 30 8s8.25 1.55 11.35 4.65C44.45 15.75 46 19.533 46 24s-1.55 8.25-4.65 11.35C38.25 38.45 34.467 40 30 40Zm5.1-8.85 2.1-2.1-5.7-5.7V16h-3v8.6l6.6 6.55ZM4 17.5v-3h8v3H4Zm-2 8v-3h10v3H2Zm2 8v-3h8v3H4Z" />
        </svg>
    );
};

export default FastTimer48Filled;
